var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookADemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E0E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.5V15.5M28 19.5V15.5M19 23.5H29M17 33.5H31C32.1046 33.5 33 32.6046 33 31.5V19.5C33 18.3954 32.1046 17.5 31 17.5H17C15.8954 17.5 15 18.3954 15 19.5V31.5C15 32.6046 15.8954 33.5 17 33.5Z",
    stroke: "#4338CA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookADemo);
export default __webpack_public_path__ + "static/media/BookADemo.5a9f0ddff651211f7f49211ac65c3786.svg";
export { ForwardRef as ReactComponent };